import React from "react";
import { withRouter } from "react-router-dom";

import moment from "moment";

import { Modal, Popover, OverlayTrigger } from "react-bootstrap";

import Slider from "rc-slider";
import { defineGrid, extendHex } from "honeycomb-grid";

import { ScrollSync, ScrollSyncPane } from "react-scroll-sync";

import Select from "react-select";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMagic,
  faDatabase,
  faChartBar,
  faList,
  faDotCircle,
  faCircle,
  faMapMarker,
  faPlay,
  faPause,
  faFastForward,
  faTrash,
  faTh
} from "@fortawesome/free-solid-svg-icons";

import { Button, ButtonGroup } from "aible";
import { LineInput } from "components/Inputs/LineInput";
import { SetupText } from "components/Next/Models/Models";
import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import LeakageChart from "components/Next/Charts/LeakageChart";
import DistributionChart from "components/Next/Charts/DistributionChart";
import OutcomeChart from "components/Next/Charts/OutcomeChart";

import FirstVarIcon from "images/Next-Icons/drill-in-2.svg";
import SecondVarIcon from "images/Next-Icons/drill-in-1.svg";
import MicroscopeIcon from "images/Next-Icons/microscope-light 1.svg";
import TelescopeIcon from "images/Next-Icons/mode-voting.svg";
import StatAssocIcon from "images/Next-Icons/stats.svg";
import PopularIcon from "images/Next-Icons/mode-voting.svg";
import VotingIcon from "images/Next-Icons/model-voting.svg";
import TrainIcon from "images/Next-Icons/TrainIcon.svg";

import ReviewDeployIcon from "images/Next-Icons/ReviewDeployIcon.svg";
import IntegrateIcon from "images/Next-Icons/IntegrateIcon.svg";
import MonitorSettingsIcon from "images/Next-Icons/MonitorSettingsIcon.svg";

import MagnifierIcon from "images/Next-Icons/MagnifierIcon.svg";
import HexIconBackground from "images/Next-Icons/HexIconBackground.svg";
import CheckmarkIcon from "images/Next-Icons/CheckmarkIcon.svg";
import PurpleBlueprintIcon from "images/Next-Icons/PurpleBlueprintIcon.svg";
import PurpleCompassIcon from "images/Next-Icons/PurpleCompassIcon.svg";
import FunnelIcon from "images/Next-Icons/FunnelIcon.svg";
import CashIcon from "images/Next-Icons/CashIcon.svg";
import SecurityCheckIcon from "images/Next-Icons/SecurityCheckIcon.svg";
import ScalesIconWhiteBackground from "images/Next-Icons/ScalesIconWhiteBackground.svg";

import JoinIcon from "images/Sense-Icons/JoinIcon.svg";
import AppendIcon from "images/Sense-Icons/AppendIcon.svg";
import DerivedIcon from "images/Sense-Icons/DerivedIcon.svg";
import FilterIcon from "images/Sense-Icons/FilterIcon.svg";
import CustomIcon from "images/Sense-Icons/CustomIcon.svg";
import IfElseIcon from "images/Sense-Icons/IfElse.svg";
import CodeIcon from "images/Sense-Icons/CodeIcon.svg";
import Code from "images/Sense-Icons/Code.svg";
import Paste from "images/Sense-Icons/Paste.svg";
import Sliders from "images/Sense-Icons/Sliders.svg";
import Sparkles from "images/Sense-Icons/Sparkles.svg";
import BanIcon from "images/Sense-Icons/ban-light.svg";
import PivotIcon from "images/Sense-Icons/angle-90-light.svg";

import TargetIcon from "images/SenseIcons/bullseye-light 1.svg";
import CompassIcon from "images/SenseIcons/compass-light 1.svg";
import HeartIcon from "images/SenseIcons/heart-pulse-light 2.svg";
import RadarIcon from "images/SenseIcons/radar-light 1.svg";
import ToolsIcon from "images/SenseIcons/tools-light 2.svg";
import GearIcon from "images/SenseIcons/cog-light 2.svg";
import ClockIcon from "images/SenseIcons/clock-rotate-left-light 1.svg";

import AibleIcon from "images/Next-Icons/AibleIcon.png";

import HexGridContainer from "containers/Next/HexGrid";
import NextSearchContainer from "containers/Next/NextSearch";
import HexagonContainer from "containers/Next/Hexagon";
import MinimapViewContainer from "containers/Next/MinimapView";
import NextReportContainer from "containers/Next/NextReport";
import TransformContainer from "containers/Next/Transform/Transform";
import ModelsContainer from "containers/Next/Models/Models";
import OverviewContainer from "containers/Next/Overview/Overview";

import ModelBoxContainer from "containers/Business/ModelBox/ModelBox";

import SelectDataWrapperContainer from "containers/UnifiedProject/SelectData/SelectDataWrapper";

import RealityCheckContainer from "containers/UnifiedProject/RealityCheck/RealityCheck";
import StrategyContainer from "containers/Business/Strategy/Strategy";
import BusinessConstraintsContainer from "containers/Business/Strategy/BusinessConstraints";
import OptimizationContainer from "containers/Business/Optimization/Optimization";
import ModelListContainer from "containers/Business/ModelList/ModelList";

import ScenarioSelectContainer from "containers/Project/ScenarioSelect";

import AssignTodoModalContainer from "containers/Market/Jobs/AssignTodoModal";

import GalleryContainer from "containers/Gallery/Gallery";

import { centerHex } from "containers/Next/NextReducer";

import DoubleOutcomeChart from "components/Next/Charts/DoubleOutcomeChart";

import { CHART_TYPES } from "containers/Report/ReportReducer";

import styles from "./style.module.css";

import { readableSearch } from "containers/Next/Models/ModelsReducer";
import { DEFAULT_LABELS } from "containers/Setup/reducer";

export default class NextFooter extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {};
  }

  renderReplayBar(allActions) {
    const { historyActions } = this.props;

    const retReplayIndex = historyActions === undefined ? -1 : historyActions.length - 2;

    return (
      <div className={styles.repHolder}>
        <div className={styles.barHolder}>
          <div className={styles.replayBarHolder}>
            <div
              className={styles.replayBar}
              id="replayBar"
              style={{
                width:
                  retReplayIndex === -1
                    ? "20px"
                    : "calc(" + ((retReplayIndex + 1) / allActions.length) * 100 + "% + 15px)"
              }}
            />
            <div
              className={styles.replayDot}
              style={{
                left: "calc(" + ((retReplayIndex + 1) / allActions.length) * 100 + "% + 11px)"
              }}
            >
              <FontAwesomeIcon icon={faCircle} />
            </div>
            <div className={styles.replayBarEmpty} />
            <div>
              {allActions.map((action, i) => {
                return (
                  <OverlayTrigger
                    key={i}
                    placement="top"
                    trigger={["hover"]}
                    rootClose
                    ref="overlay"
                    overlay={
                      <Popover id="popover-positioned-top">
                        <div className={styles.pFlex}>
                          <div className={styles.pAction}>{action.label}</div>
                          <div className={styles.pSub}>{action.subItem}</div>
                          <div className={styles.pDate} style={{ marginTop: "5px" }}>
                            {action.date !== undefined
                              ? action.date
                              : moment.utc(action.badDate).local().format("MMMM Do YYYY, h:mm:ss a")}
                          </div>
                        </div>
                      </Popover>
                    }
                  >
                    <div
                      className={styles.replayAction}
                      style={{
                        left: "calc(" + (i / allActions.length) * 100 + "% + 15px)"
                      }}
                      title={action.label}
                    >
                      <div className={styles.dotIcon}>
                        <FontAwesomeIcon
                          icon={faCircle}
                          style={{
                            color: i <= retReplayIndex ? "white" : "#7e69d7"
                          }}
                        />
                      </div>
                      <div
                        className={styles.nIcon}
                        style={{ background: "transparent", cursor: "pointer" }}
                        onClick={() => {}}
                      >
                        <img src={action.icon} style={{ background: "transparent" }} />
                      </div>
                    </div>
                  </OverlayTrigger>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { dataset, historyActions, pendingActions } = this.props;

    let actions = [...historyActions, ...pendingActions];

    return (
      <div className={styles.footer}>
        <img src={ToolsIcon} style={{ height: "16px", width: "16px", marginRight: "3px" }} />
        <div>
          <div className={styles.fSub}>{dataset?.label}</div>
          <div className={styles.fBold}>{"Transformations"}</div>
        </div>
        <div className={styles.rHolder}>{this.renderReplayBar(actions || [])}</div>
      </div>
    );
  }
}
